module.exports = __webpack_public_path__ + "static/media/test_specialFormatting_blanks.a29326fb.csv";